import { Api } from 'models/services/api';
import { ReadOriginalMenuCategoriesQuery } from 'models/services/graphql';

import { OriginalMenuCategoryCollectionData } from '../collection';

type DataToRead = {
  nextToken?: string;
};

const RequestQuery = `
  query ReadOriginalMenuCategories($nextToken: String) {
    ${ReadOriginalMenuCategoriesQuery}
  }
`;

type ResponseData = {
  data: {
    readOriginalMenuCategories: OriginalMenuCategoryCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: OriginalMenuCategoryCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead = {}): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readOriginalMenuCategories;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };